import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function InvestorsPage() {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [user, setUser] = useState(null);

    useEffect(() => {
        const uJson = localStorage.getItem('user');
        if (uJson) setUser(JSON.parse(uJson));
    }, []);

    return (
        <div className="min-h-screen bg-[#0a0c10] text-slate-300 font-sans">
            {/* Background */}
            <div className="fixed inset-0 pointer-events-none overflow-hidden z-0">
                <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,rgba(15,23,20,0.8)_0%,transparent_60%)]"></div>
                <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-emerald-900/30 to-transparent"></div>
            </div>

            {/* Nav Header (Edge-to-Edge Flat Border Style matching landing page) */}
            <header className="border-b border-white/5 mb-16 relative z-10">
                <div className="container mx-auto px-6">
                    <div className="flex justify-between items-center h-16">
                        
                        {/* Logo */}
                        <Link to="/" className="flex items-center gap-3">
                            <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                                <svg className="w-7 h-7 text-emerald-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M2 20L8 8L13 16" />
                                    <path d="M8 20L15 6L22 20" />
                                    <path d="M8 8L15 6" strokeDasharray="1.5 1.5" />
                                    <circle cx="15" cy="6" r="1.5" fill="currentColor" />
                                </svg>
                            </div>
                            <div>
                                <p className="text-sm font-semibold text-white leading-none tracking-tight">
                                    Silicon Himalayas Ledger
                                </p>
                                <p className="text-[9px] text-slate-500 uppercase tracking-widest font-medium mt-0.5">
                                    Green Energy Certificate Platform
                                </p>
                            </div>
                            <span className="text-[9px] text-slate-600 ml-2 pl-2 border-l border-white/10 hidden sm:inline-block">
                                Investors Portal
                            </span>
                        </Link>

                        {/* Desktop Nav links */}
                        <nav className="hidden sm:flex items-center gap-1">
                            <Link to="/verify" className="px-4 py-2 text-xs font-medium text-slate-400 hover:text-white transition">
                                Verify Certificate
                            </Link>
                            <Link to="/investors" className="px-4 py-2 text-xs font-semibold text-emerald-400 border-b-2 border-emerald-500/30 transition">
                                Investors
                            </Link>
                            <a href="https://silicon-himalayas.com" target="_blank" rel="noopener noreferrer" className="px-4 py-2 text-xs font-medium text-slate-400 hover:text-white transition">
                                About
                            </a>
                            <div className="w-px h-4 bg-white/10 mx-2"></div>
                            {user ? (
                                <Link to={
                                    user.role === 'admin' ? '/admin' 
                                    : user.role === 'expert' ? '/dashboard/expert' 
                                    : user.role === 'investor' ? '/dashboard/investor' 
                                    : user.role === 'observer' ? '/dashboard/observer' 
                                    : '/dashboard'
                                } className="px-4 py-2 bg-emerald-600/10 hover:bg-emerald-600/20 text-emerald-400 border border-emerald-600/20 rounded-lg text-xs font-semibold transition flex items-center gap-2">
                                    <span className="w-1.5 h-1.5 bg-emerald-500 rounded-full animate-pulse"></span>
                                    {user.role === 'expert' ? 'Verifier Portal' : `${user.role?.charAt(0).toUpperCase() + user.role?.slice(1)} Portal`}
                                </Link>
                            ) : (
                                <>
                                    <Link to="/login" className="px-4 py-2 text-xs font-medium text-slate-300 hover:text-white transition">
                                        Sign In
                                    </Link>
                                    <Link to="/register" className="px-4 py-2 bg-emerald-600 hover:bg-emerald-500 text-white rounded-lg text-xs font-semibold transition">
                                        Register
                                    </Link>
                                </>
                            )}
                        </nav>

                        {/* Hamburger Button (Mobile) */}
                        <button 
                            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                            className="sm:hidden p-2 text-slate-400 hover:text-white transition focus:outline-none"
                            aria-label="Toggle menu"
                        >
                            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                {mobileMenuOpen ? (
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                                ) : (
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                                )}
                            </svg>
                        </button>
                    </div>

                    {/* Mobile Menu Panel */}
                    {mobileMenuOpen && (
                        <div className="sm:hidden border-t border-white/5 py-4 flex flex-col gap-2 animate-fade-in relative z-20 bg-[#0a0c10]/95 backdrop-blur-md rounded-b-xl px-2">
                            <Link 
                                to="/verify" 
                                onClick={() => setMobileMenuOpen(false)}
                                className="px-4 py-2 text-sm font-medium text-slate-400 hover:text-white transition"
                            >
                                Verify Certificate
                            </Link>
                            <Link 
                                to="/investors" 
                                onClick={() => setMobileMenuOpen(false)}
                                className="px-4 py-2 text-sm font-medium text-slate-400 hover:text-white transition"
                            >
                                Investors
                            </Link>
                            <a 
                                href="https://silicon-himalayas.com" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                onClick={() => setMobileMenuOpen(false)}
                                className="px-4 py-2 text-sm font-medium text-slate-400 hover:text-white transition"
                            >
                                About
                            </a>
                            <div className="h-px bg-white/10 my-1 mx-4"></div>
                            {user ? (
                                <Link 
                                    to={
                                        user.role === 'admin' ? '/admin' 
                                        : user.role === 'expert' ? '/dashboard/expert' 
                                        : user.role === 'investor' ? '/dashboard/investor' 
                                        : user.role === 'observer' ? '/dashboard/observer' 
                                        : '/dashboard'
                                    } 
                                    onClick={() => setMobileMenuOpen(false)}
                                    className="mx-4 px-4 py-3 bg-emerald-600/10 hover:bg-emerald-600/20 text-emerald-400 border border-emerald-600/20 rounded-lg text-sm font-semibold transition flex items-center justify-center gap-2"
                                >
                                    <span className="w-1.5 h-1.5 bg-emerald-500 rounded-full animate-pulse"></span>
                                    {user.role === 'expert' ? 'Verifier Portal' : `${user.role?.charAt(0).toUpperCase() + user.role?.slice(1)} Portal`}
                                </Link>
                            ) : (
                                <div className="flex flex-col gap-2 px-4 mt-2">
                                    <Link 
                                        to="/login" 
                                        onClick={() => setMobileMenuOpen(false)}
                                        className="py-2.5 text-sm font-medium text-slate-300 hover:text-white text-center transition border border-white/10 rounded-lg"
                                    >
                                        Sign In
                                    </Link>
                                    <Link 
                                        to="/register" 
                                        onClick={() => setMobileMenuOpen(false)}
                                        className="py-2.5 bg-emerald-600 hover:bg-emerald-500 text-white rounded-lg text-sm font-semibold text-center transition"
                                    >
                                        Register
                                    </Link>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </header>

            <div className="container mx-auto px-6 py-12 relative z-10">
                {/* Hero Section */}
                <section className="mb-16 animate-fade-in">
                    <h2 className="text-4xl sm:text-5xl font-black mb-6 tracking-tight leading-tight max-w-3xl font-display text-white">
                        Investment in Nepal's Green Finance Infrastructure
                    </h2>
                    <p className="text-slate-400 max-w-3xl text-lg mb-8 leading-relaxed">
                        Silicon Himalayas Ledger is a pre-revenue, sandbox-stage 
                        platform building regulated digital infrastructure for 
                        I-REC renewable energy certificates in Nepal. We are 
                        raising <strong className="text-white">USD 3,00,000</strong> in pre-seed capital to fund our 18-month runway, product development, and registry licensing.
                    </p>

                    {/* Status Badges */}
                    <div className="flex flex-wrap gap-3 mb-10">
                        {[
                            { label: 'Stage', value: 'Pre-Seed' },
                            { label: 'Raise Target', value: 'USD 3,00,000' },
                            { label: 'Use of Funds', value: '18-Month Runway, Development & Licensing' },
                            { label: 'NRB Status', value: 'Sandbox Engaged' }
                        ].map((b, i) => (
                            <span key={i} className="px-4 py-2 bg-emerald-500/10 text-emerald-400 border border-emerald-500/20 rounded-xl text-xs font-bold uppercase tracking-wider">
                                {b.label}: {b.value}
                            </span>
                        ))}
                    </div>

                    {/* Target Investor Focus & Lifecycle Disclosure Section */}
                    <div className="border border-white/8 rounded-xl bg-white/2 p-6 max-w-4xl">
                        <h4 className="text-xs font-semibold uppercase tracking-widest text-white mb-3">
                            Target Investor Focus & Project Lifecycle Disclosure
                        </h4>
                        <div className="space-y-3 text-sm text-slate-400 leading-relaxed">
                            <p>
                                <strong className="text-emerald-400">Target Investors:</strong> We are seeking partnerships with Development Finance Institutions (DFIs), climate-focused venture capital funds, institutional ESG investors, and strategic angel investors, local as well as international, who understand the transformative potential of environmental asset markets in developing economies.
                            </p>
                            <p>
                                <strong className="text-emerald-400">Project Stage & Lifecycle Disclosure:</strong> Silicon Himalayas Ledger is currently in its regulatory sandbox phase (pre-revenue, pre-commercialization). As a platform for issuing and trading I-RECs (International Renewable Energy Certificates), our business lifecycle is aligned with Nepal's multi-decadal green transition. While the platform technology is fully operational on a testnet, no certificates have been formally issued yet. Generation data and platform fees will commence following project commissioning and standard regulatory validation (estimated Q3 2027).
                            </p>
                        </div>
                    </div>
                </section>

                {/* Opportunity Grid */}
                <section className="mb-16 grid grid-cols-1 md:grid-cols-3 gap-6">
                    <div className="glass p-8 rounded-3xl border-white/5 space-y-4">
                        <div className="text-2xl text-emerald-400">🏔</div>
                        <h3 className="font-bold text-lg text-slate-100">Nepal Renewable Potential</h3>
                        <p className="text-slate-400 text-sm leading-relaxed">
                            3,200+ MW installed hydropower capacity. Solar growing rapidly. Among Asia's highest capacity factors for run-of-river hydro.
                        </p>
                        <p className="text-[10px] text-slate-600 font-bold uppercase">Source: NEA 2025</p>
                    </div>

                    <div className="glass p-8 rounded-3xl border-white/5 space-y-4">
                        <div className="text-2xl text-cyan-400">🌍</div>
                        <h3 className="font-bold text-lg text-slate-100">Global I-REC Market</h3>
                        <p className="text-slate-400 text-sm leading-relaxed">
                            I-REC(E) operational in 70+ countries. 4,000+ corporate participants. Growing Scope 2 demand from Asian corporate buyers.
                        </p>
                        <p className="text-[10px] text-slate-600 font-bold uppercase">Source: I-TRACK Foundation 2025</p>
                    </div>

                    <div className="glass p-8 rounded-3xl border-white/5 space-y-4">
                        <div className="text-2xl text-blue-400">⚖️</div>
                        <h3 className="font-bold text-lg text-slate-100">Nepal's Policy Moment</h3>
                        <p className="text-slate-400 text-sm leading-relaxed">
                            Carbon Trading Regulation enacted 2025. Article 6.2 bilateral agreement signed with Sweden at COP29. Active government mandate for green finance development.
                        </p>
                        <p className="text-[10px] text-slate-600 font-bold uppercase">Source: COP29 Bilaterals</p>
                    </div>
                </section>

                {/* Winding Road Milestone Roadmap Section */}
                <section className="mb-20">
                    <div className="flex items-center gap-3 mb-12">
                        <p className="text-[10px] font-semibold uppercase tracking-widest text-slate-500">
                            Winding Road to Commercial Scale
                        </p>
                        <div className="flex-1 h-px bg-white/5"></div>
                    </div>

                    <div className="relative max-w-5xl mx-auto px-4 sm:px-6">
                        {/* Winding Road Center Path */}
                        <div className="absolute left-4 sm:left-1/2 transform sm:-translate-x-1/2 top-4 bottom-4 w-1 bg-gradient-to-b from-emerald-500 via-cyan-500 to-slate-800 rounded-full z-0 opacity-40"></div>
                        
                        <div className="space-y-16 relative z-10">
                            {[
                                {
                                    phase: 'Phase 01',
                                    quarter: 'Q2 2026 (Current Phase)',
                                    title: 'Regulatory Sandbox & Pilot',
                                    desc: 'Formal sandbox participation with the central bank. Onboarding and integration testing of the first 10MW pilot solar farm on our Hyperledger Fabric testnet.',
                                    align: 'left',
                                    status: 'active'
                                },
                                {
                                    phase: 'Phase 02',
                                    quarter: 'H1 2027',
                                    title: 'API Integrations & Security Audits',
                                    desc: 'Writing secure meter-to-ledger API adapters and deploying cryptographic keys for verifiers. Undertaking smart contract and Fabric chaincode audit runs.',
                                    align: 'right',
                                    status: 'upcoming'
                                },
                                {
                                    phase: 'Phase 03',
                                    quarter: 'Q3 2027',
                                    title: 'Project Commissioning',
                                    desc: 'Full commercial commissioning of onboarding projects in Bagmati Province. Activation of live solar and hydro sensor attestation pipeline on the ledger.',
                                    align: 'left',
                                    status: 'upcoming'
                                },
                                {
                                    phase: 'Phase 04',
                                    quarter: 'Q1 2028',
                                    title: 'GCC Registry Accreditation',
                                    desc: 'Completing Evident Registry and GCC registrar verification checklist audits to issue officially recognized green energy certificates (I-RECs).',
                                    align: 'right',
                                    status: 'upcoming'
                                },
                                {
                                    phase: 'Phase 05',
                                    quarter: 'H2 2028 & Beyond',
                                    title: 'Offtaker Marketplace Launch',
                                    desc: 'Transition to mainnet deployment. Connecting international corporate ESG buyers with certified hydro/solar generators for cross-border carbon offsetting.',
                                    align: 'left',
                                    status: 'upcoming'
                                }
                            ].map((m, i) => (
                                <div key={i} className={`flex flex-col sm:flex-row items-center justify-between ${m.align === 'left' ? 'sm:flex-row-reverse' : ''}`}>
                                    {/* Empty spacer block to hold alignment on desktop */}
                                    <div className="hidden sm:block w-[45%]"></div>
                                    
                                    {/* Road Node Marker */}
                                    <div className="absolute left-4 sm:left-1/2 transform -translate-x-1.5 sm:-translate-x-1/2 w-4 h-4 rounded-full border-4 bg-[#0a0c10] z-20 flex items-center justify-center transition-all duration-300 hover:scale-125 border-emerald-500">
                                        <span className={`w-1.5 h-1.5 rounded-full ${m.status === 'active' ? 'bg-emerald-400 animate-pulse' : 'bg-slate-700'}`}></span>
                                    </div>

                                    {/* Milestone Card */}
                                    <div className={`w-[90%] sm:w-[45%] ml-10 sm:ml-0 border bg-white/2 hover:bg-white/4 transition-all duration-300 p-6 rounded-xl relative ${m.status === 'active' ? 'border-emerald-500/30' : 'border-white/8'}`}>
                                        <div className="flex justify-between items-baseline mb-2">
                                            <span className={`text-[10px] font-bold uppercase tracking-wider ${m.status === 'active' ? 'text-emerald-400' : 'text-slate-500'}`}>{m.quarter}</span>
                                            <span className="text-[10px] text-slate-700 font-bold font-mono">{m.phase}</span>
                                        </div>
                                        <h4 className="font-semibold text-white mb-2 text-base">{m.title}</h4>
                                        <p className="text-xs text-slate-400 leading-relaxed">{m.desc}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* What We've Built */}
                <section className="mb-16 glass p-8 sm:p-10 rounded-3xl border-white/5">
                    <h3 className="text-xl font-bold mb-6 text-slate-100">What We've Built</h3>
                    <p className="text-slate-400 text-sm mb-6">
                        In the past two months, Silicon Himalayas has built:
                    </p>
                    <ul className="space-y-3 text-slate-300 text-sm list-disc pl-5 mb-8">
                        <li>A working Hyperledger Fabric v2.5 permissioned ledger with chaincode for certificate issuance, transfer, and retirement.</li>
                        <li>Role-based dashboards for administrators, technical verifiers, investors, and regulatory observers.</li>
                        <li>A sensor-to-attestation pipeline with Ed25519 cryptographic verification.</li>
                        <li>An NRB observer dashboard with real-time capital flow monitoring.</li>
                        <li>Integration architecture designed for GCC/Evident I-REC registry pipeline.</li>
                        <li>One active solar project partner (10MW, under SPV structuring).</li>
                    </ul>
                    <div className="p-4 bg-yellow-500/5 border border-yellow-500/10 rounded-2xl">
                        <p className="text-[10px] text-slate-500 font-bold uppercase">Important Credibility Note</p>
                        <p className="text-xs text-slate-400 mt-1">
                            The platform is in sandbox phase. No I-RECs have been formally issued. Generation data is available following project commissioning, estimated Q3 2027.
                        </p>
                    </div>
                </section>

                {/* Business Model */}
                <section className="mb-16">
                    <h3 className="text-xl font-bold mb-6 text-slate-100">Business Model</h3>
                    <div className="overflow-x-auto">
                        <table className="w-full text-left text-sm border-collapse">
                            <thead>
                                <tr className="border-b border-white/10 text-slate-500 text-xs uppercase tracking-widest">
                                    <th className="py-3">Revenue Stream</th>
                                    <th className="py-3">Mechanism</th>
                                    <th className="py-3 text-right">When</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-white/5 text-slate-300">
                                <tr>
                                    <td className="py-4 font-bold text-white">Platform fee</td>
                                    <td className="py-4">% of I-REC transaction value (2-5%)</td>
                                    <td className="py-4 text-right">Post-commissioning</td>
                                </tr>
                                <tr>
                                    <td className="py-4 font-bold text-white">Registrant services</td>
                                    <td className="py-4">Annual fee for GCC/Evident registration support</td>
                                    <td className="py-4 text-right">Near-term</td>
                                </tr>
                                <tr>
                                    <td className="py-4 font-bold text-white">Advisory pipeline</td>
                                    <td className="py-4">SPV structuring projects feed platform</td>
                                    <td className="py-4 text-right">Ongoing</td>
                                </tr>
                                <tr>
                                    <td className="py-4 font-bold text-white">Data/reporting</td>
                                    <td className="py-4">Observer API for institutional buyers</td>
                                    <td className="py-4 text-right">Future</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </section>

                {/* Use of Funds */}
                <section className="mb-16">
                    <h3 className="text-xl font-bold mb-6 text-slate-100">Use of Funds</h3>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                        {[
                            { 
                                label: 'Deployment & infra', 
                                pct: '25%',
                                details: 'Cloud hosting nodes, cryptographic hardware for IoT meters, and comprehensive security/smart contract auditing.'
                            },
                            { 
                                label: 'GCC/Evident & legal', 
                                pct: '20%',
                                details: 'Accreditation application fees, international legal advisory, regulatory document translation, and compliance validation.'
                            },
                            { 
                                label: 'Team (tech + compliance)', 
                                pct: '40%',
                                details: 'Compensation for core engineering specialists, systems architects, regulatory officers, and project onboarding managers.'
                            },
                            { 
                                label: 'Regulatory engagement', 
                                pct: '15%',
                                details: 'NRB sandbox operations, integration testing with central bank interfaces, policy advocacy, and public reporting.'
                            }
                        ].map((f, i) => (
                            <div key={i} className="border border-white/8 bg-white/2 hover:bg-white/4 transition p-6 rounded-xl space-y-3">
                                <div className="flex justify-between items-baseline">
                                    <span className="text-3xl font-black text-emerald-400">{f.pct}</span>
                                    <span className="text-[10px] text-slate-500 font-bold uppercase tracking-wider">Allocation</span>
                                </div>
                                <h4 className="font-semibold text-white text-sm tracking-tight">{f.label}</h4>
                                <p className="text-xs text-slate-400 leading-relaxed">{f.details}</p>
                            </div>
                        ))}
                    </div>
                </section>

                {/* Regulatory Section */}
                <section className="mb-16 glass p-8 sm:p-10 rounded-3xl border-white/5">
                    <h3 className="text-xl font-bold mb-4 text-slate-100">Regulatory Architecture</h3>
                    <p className="text-slate-400 text-sm leading-relaxed mb-6">
                        The platform operates on Hyperledger Fabric — a permissioned, 
                        private blockchain with no native token or cryptocurrency 
                        component. Settlement is in fiat currency. NRB has been engaged 
                        for sandbox participation under their 2025 fintech regulatory 
                        sandbox framework. The platform is designed for full regulatory 
                        transparency: NRB has read-only access to all transaction data 
                        via a dedicated observer node.
                    </p>
                    <div className="overflow-x-auto">
                        <table className="w-full text-left text-xs border-collapse">
                            <thead>
                                <tr className="border-b border-white/10 text-slate-500 uppercase tracking-widest">
                                    <th className="py-3">Requirement</th>
                                    <th className="py-3 text-right">Implementation</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-white/5 text-slate-300">
                                <tr>
                                    <td className="py-4 font-bold text-white">No cryptocurrency</td>
                                    <td className="py-4 text-right">Hyperledger Fabric, fiat settlement only</td>
                                </tr>
                                <tr>
                                    <td className="py-4 font-bold text-white">KYC/AML</td>
                                    <td className="py-4 text-right">Built-in with sanctions screening</td>
                                </tr>
                                <tr>
                                    <td className="py-4 font-bold text-white">Data sovereignty</td>
                                    <td className="py-4 text-right">Nepal-hosted infrastructure (DOIT-registered)</td>
                                </tr>
                                <tr>
                                    <td className="py-4 font-bold text-white">Record retention</td>
                                    <td className="py-4 text-right">PostgreSQL with pgAudit, 5-year minimum</td>
                                </tr>
                                <tr>
                                    <td className="py-4 font-bold text-white">Regulatory access</td>
                                    <td className="py-4 text-right">Real-time NRB observer dashboard</td>
                                </tr>
                                <tr>
                                    <td className="py-4 font-bold text-white">International standard</td>
                                    <td className="py-4 text-right">I-REC(E) via GCC and Evident Registry</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </section>

                {/* Risk Section */}
                <section className="mb-16">
                    <h3 className="text-xl font-bold mb-6 text-slate-100">Risks and Mitigants</h3>
                    <div className="overflow-x-auto">
                        <table className="w-full text-left text-xs border-collapse">
                            <thead>
                                <tr className="border-b border-white/10 text-slate-500 uppercase tracking-widest">
                                    <th className="py-3">Risk</th>
                                    <th className="py-3 text-right">Mitigant</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-white/5 text-slate-300">
                                <tr>
                                    <td className="py-4 font-bold text-white pr-4">NRB regulatory classification unclear for tokenized assets</td>
                                    <td className="py-4 text-right">Engaged NRB for sandbox; platform designed as permissioned ledger with fiat settlement, not a digital asset</td>
                                </tr>
                                <tr>
                                    <td className="py-4 font-bold text-white pr-4">I-REC buyer demand for Nepal-origin certificates unproven</td>
                                    <td className="py-4 text-right">GCC/Evident ecosystem has 4,000+ existing participants; bilateral Article 6.2 demand growing</td>
                                </tr>
                                <tr>
                                    <td className="py-4 font-bold text-white pr-4">Carbon Trading Regulation 2025 has structural issues</td>
                                    <td className="py-4 text-right">Platform focuses on I-RECs (not carbon credits) — separate regulatory path</td>
                                </tr>
                                <tr>
                                    <td className="py-4 font-bold text-white pr-4">Pre-revenue; no generation data for 6 months</td>
                                    <td className="py-4 text-right">Runway covers this period; advisory revenue possible in parallel</td>
                                </tr>
                                <tr>
                                    <td className="py-4 font-bold text-white pr-4">Solo technical build</td>
                                    <td className="py-4 text-right">Raising specifically to add technical and compliance team capacity</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </section>

                {/* Team Section */}
                <section className="mb-16 glass p-8 sm:p-10 rounded-3xl border-white/5">
                    <h3 className="text-xl font-bold mb-8 text-slate-100">
                        Founding Team
                    </h3>
                    
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                        {/* Santosh Poudel */}
                        <div className="space-y-4">
                            <div className="flex items-center gap-4">
                                <div className="w-12 h-12 rounded-xl bg-emerald-500/10 border border-emerald-500/20 flex items-center justify-center text-emerald-400 font-bold text-lg flex-shrink-0">
                                    SP
                                </div>
                                <div>
                                    <h4 className="font-bold text-white text-base">Santosh Poudel</h4>
                                    <p className="text-[10px] text-slate-500 uppercase tracking-widest font-semibold">Co-Founder & Strategic Advisor (The Brain)</p>
                                </div>
                            </div>
                            <p className="text-slate-400 text-xs leading-relaxed">
                                Over 13 years of experience in Nepal's financial sector (securities research, PE structuring, capital market analytics). Founder of Finlogic Capital and strategic advisor to Silicon Himalayas. Pursued CA at ICAI, holds an MBA, and carries certifications in Sustainable Finance & Blockchain. He is also a hands-on developer, having written and audited the platform's Hyperledger Fabric Go chaincode and Node.js gateway API infrastructure.
                            </p>
                        </div>

                        {/* Amrit Rana Chhetri */}
                        <div className="space-y-4">
                            <div className="flex items-center gap-4">
                                <div className="w-12 h-12 rounded-xl bg-cyan-500/10 border border-cyan-500/20 flex items-center justify-center text-cyan-400 font-bold text-lg flex-shrink-0">
                                    AC
                                </div>
                                <div>
                                    <h4 className="font-bold text-white text-base">Amrit Rana Chhetri</h4>
                                    <p className="text-[10px] text-slate-500 uppercase tracking-widest font-semibold">Co-Founder & Director (The Face)</p>
                                </div>
                            </div>
                            <p className="text-slate-400 text-xs leading-relaxed">
                                Clean energy developer and regulated fund manager. Director of Investor Relations at GlobeX Global Fund Management (GGFM) and Founder of GlobeX Technology. Holds an International Finance degree (UK) and bridges international expectations with Nepalese regulatory realities.
                            </p>
                        </div>

                        {/* Himal Aryal */}
                        <div className="space-y-4">
                            <div className="flex items-center gap-4">
                                <div className="w-12 h-12 rounded-xl bg-blue-500/10 border border-blue-500/20 flex items-center justify-center text-blue-400 font-bold text-lg flex-shrink-0">
                                    HA
                                </div>
                                <div>
                                    <h4 className="font-bold text-white text-base">Himal Aryal</h4>
                                    <p className="text-[10px] text-slate-500 uppercase tracking-widest font-semibold">Co-Founder (The Network)</p>
                                </div>
                            </div>
                            <p className="text-slate-400 text-xs leading-relaxed">
                                Seasoned civil infrastructure entrepreneur with over 15 years of construction management experience in Nepal. Supervised execution of utility-scale construction projects, with specialized footprint in run-of-river hydropower site developments, grid substation connectivity, and utility-scale solar racking foundation engineering.
                            </p>
                        </div>
                    </div>

                    {/* Partnership Details */}
                    <div className="mt-8 pt-6 border-t border-white/5 space-y-4">
                        <p className="text-xs text-slate-500 leading-relaxed">
                            <span className="text-slate-400 font-bold">Silicon Himalayas Advisory:</span> Silicon Himalayas Pvt Ltd acts as our core project advisory and development engine operating across five high-potential verticals: Green Energy, Technology & Digital, Agri-tech, Tourism, and Smart Infrastructure.
                        </p>
                        <p className="text-[10px] text-slate-600">
                            Silicon Himalayas Pvt. Ltd. · Kathmandu, Nepal · Reg No: OCR 82/83-19-101587512
                        </p>
                    </div>
                </section>

                {/* Conflict of Interest Disclosure */}
                <section className="mb-16 glass p-8 sm:p-10 rounded-3xl border-amber-500/10 bg-amber-500/3">
                    <h3 className="text-xl font-bold mb-4 text-slate-100">
                        Conflict of Interest Disclosure & Consulting Scope
                    </h3>
                    <p className="text-slate-400 text-sm leading-relaxed mb-4">
                        Silicon Himalayas Pvt Ltd and its affiliates operate as a multi-vertical advisory firm, providing strategic consulting, procurement, and project development services across five key sectors: Green Energy, Technology & Digital, Agri-tech, Tourism, and Smart Infrastructure.
                    </p>
                    <p className="text-slate-400 text-sm leading-relaxed mb-4">
                        Because we advise project developers in these diverse verticals while simultaneously operating the green energy registry and certificate platform, a structural conflict of interest may arise. For example, our advisory team may consult on an SPV structure or tech development for a project that subsequently lists environmental certificates or operational assets on this marketplace platform.
                    </p>
                    <p className="text-slate-400 text-sm leading-relaxed mb-4">
                        <strong>Mitigant:</strong> The Technical Verification function is structurally separated from all consulting and advisory engagements. Committee Verifiers sign generation data attestations independently using individual cryptographic keys. No single party can issue a certificate unilaterally — multi-signature verification is enforced at the chaincode level.
                    </p>
                    <p className="text-slate-400 text-sm leading-relaxed">
                        Investors are encouraged to conduct independent due diligence. This disclosure will be updated as our governance structures mature post-seed-funding.
                    </p>
                </section>

                {/* Data Governance */}
                <section className="mb-16 glass p-8 sm:p-10 rounded-3xl border-white/5">
                    <h3 className="text-xl font-bold mb-4 text-slate-100">
                        Data Governance
                    </h3>
                    <div className="overflow-x-auto">
                        <table className="w-full text-left text-xs border-collapse">
                            <thead>
                                <tr className="border-b border-white/10 text-slate-500 uppercase tracking-widest">
                                    <th className="py-3">Category</th>
                                    <th className="py-3 text-right">
                                        Policy
                                    </th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-white/5 text-slate-300">
                                <tr>
                                    <td className="py-4 font-bold text-white">
                                        Data Residency
                                    </td>
                                    <td className="py-4 text-right">
                                        All data hosted in Nepal 
                                        (DOIT-registered infrastructure). 
                                        No cross-border data transfer.
                                    </td>
                                </tr>
                                <tr>
                                    <td className="py-4 font-bold text-white">
                                        Personal Data
                                    </td>
                                    <td className="py-4 text-right">
                                        KYC data encrypted at rest. 
                                        Retained 5 years post-account 
                                        closure per NRB guidelines.
                                    </td>
                                </tr>
                                <tr>
                                    <td className="py-4 font-bold text-white">
                                        Audit Logs
                                    </td>
                                    <td className="py-4 text-right">
                                        All DDL/DML operations logged 
                                        via pgAudit. Immutable 
                                        blockchain record on 
                                        Hyperledger Fabric.
                                    </td>
                                </tr>
                                <tr>
                                    <td className="py-4 font-bold text-white">
                                        Regulatory Access
                                    </td>
                                    <td className="py-4 text-right">
                                        NRB granted full read-only 
                                        access via dedicated 
                                        observer node.
                                    </td>
                                </tr>
                                <tr>
                                    <td className="py-4 font-bold text-white">
                                        Applicable Law
                                    </td>
                                    <td className="py-4 text-right">
                                        Nepal law. Privacy Policy 
                                        available on request.
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </section>

                {/* Contact Section */}
                <section className="glass p-8 sm:p-10 rounded-3xl border-white/5 text-center space-y-4">
                    <h3 className="text-xl font-bold text-white">Contact & Next Steps</h3>
                    <p className="text-slate-400 text-sm max-w-lg mx-auto">
                        To request a sandbox demo, data room access, or introductory call:
                    </p>
                    <div className="flex flex-col sm:flex-row justify-center gap-6 text-sm font-bold text-cyan-400 mt-4">
                        <a href="mailto:office@silicon-himalayas.com" className="hover:text-cyan-300 transition">
                            📧 office@silicon-himalayas.com
                        </a>
                        <a href="https://sandbox.silicon-himalayas.com" className="hover:text-cyan-300 transition">
                            🖥 sandbox.silicon-himalayas.com
                        </a>
                        <a href="https://silicon-himalayas.com" className="hover:text-cyan-300 transition">
                            🌐 silicon-himalayas.com
                        </a>
                    </div>
                    <p className="text-[10px] text-slate-600 mt-4 uppercase tracking-widest font-black">
                        Sandbox demo credentials available on request.
                    </p>
                </section>
            </div>
        </div>
    );
}
